module.exports = __webpack_public_path__ + "static/media/4.77aa7b35.jpg";